import React from "react";
import Header from "../contentReaderMarkdown/Header";
import CodeComponent from "./codeComponent";
import LinkExpire from "../contentReaderMarkdown/linkExpire";
import "./contentReaderLink.css";
import ViewSharedContent from "./viewSharedContent";
import DobComp from "./verifyDob";

const ContentReaderLink = () => {
   const searchParams = new URLSearchParams(window.location.search);
   const queryId = searchParams.get("id");
   const queryValidation = searchParams.get("validation") || "dob";
   return (
      <div className="py-2 h-100">
         <Header isPro={true} />
         {queryValidation?.toLowerCase() === "code" ? (
            <CodeComponent id={queryId} validation={queryValidation} />
         ) : queryValidation?.toLowerCase() === "none" ? (
            <div className="h-90">
               <ViewSharedContent id={queryId} validation={queryValidation} />
            </div>
         ) : queryValidation?.toLowerCase() === "dob" ? (
            <div className="h-90">
               <DobComp id={queryId} validation={queryValidation} />
            </div>
         ) : (
            <div className="link-expire-cont">
               <LinkExpire />
            </div>
         )}
      </div>
   );
};

export default ContentReaderLink;
